import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';

import MainLayout from 'components/templates/main-layout';

import Button from 'components/common/button';
import { Card, CardBody } from 'components/common/card';
import confirmation from 'components/common/confirmation';
import Hr from 'components/common/hr';
import Input from 'components/common/input';
import Loader from 'components/common/loader';
import Typography from 'components/common/typography';
import toast from 'components/common/toast';

import {
  Form,
  Actions,
} from './elements';

import { CREAR_UBICACION } from './requests';

class ubicacionAgregar extends Component {
  state = {
    tag: '',
    loadingUbicacion: false,
  };

  handleUbicacionChange = event => {
    const {
      target: { value },
    } = event;

    this.setState({ tag: value });
  }

  clearInput = () => this.setState({ tag: '' });

  crearUbicacion = async () => {
    const { client } = this.props;
    const { tag } = this.state;

    if (await confirmation('¿Estás seguro?')) {
      this.setState({ loadingUbicacion: true });

      try {
        const { errors } = await client.mutate({
          mutation: CREAR_UBICACION,
          variables: { data: { tag } },
        });

        if (errors) {
          let message;
          const [error] = errors;
          message = 'Algo salió mal, intentalo de nuevo';
          toast.error(message);
          this.setState({ loadingUbicacion: false });
          return;
        }

        toast.success('Ubicacion creada éxitosamente');
        this.clearInput();
      } catch (error) {
        toast.error('Algo salió mal, intentalo cerrando sesíon e iniciando nuevamente');
      } finally {
        this.setState({ loadingUbicacion: false });
      }
    }
  };

  render() {
    const {
      tag,
      loadingUbicacion,
    } = this.state;

    return (
      <MainLayout flexColumn>
        <Typography sm>
          Agregar una ubicacion nueva
        </Typography>
        <Hr />
        <Card marginT="30">
          <CardBody>
            <Form>
              <Actions>
                <div className="input-container">
                  <Input
                    input
                    primary
                    label="Escribe el nombre de una la nueva ubicacion:"
                    required
                    placeholder="Nombre de ubicacion"
                    type="text"
		    value={tag}
                    onChange={this.handleUbicacionChange}
                  />
                </div>                  
              </Actions>
            </Form>
          </CardBody>
        </Card>
        {loadingUbicacion ? (
          <Loader alignSelf="flex-end" marginT="40" />
        ) : (
          <Button
            alignSelf="flex-end"
            type="button"
            sm
            marginT="40"
            not={!tag.length}
            disabled={!tag.length}
            onClick={this.crearUbicacion}
          >
            Crear ubicacion
          </Button>
        )}
      </MainLayout>
    );
  }
}

ubicacionAgregar.propTypes = {
  client: PropTypes.shape().isRequired,
};

export default withApollo(ubicacionAgregar);
